import CRUDgeneric from 'utils/CRUDgeneric';

// Defino a donde el cliente consumira los enpoints.
const _cliente = CRUDgeneric('/nominas/configurar-guardias-vacacionales-general/');
// El nombre del modelo que aparecera al agregar y editar.
const _nameModel = 'Configuración de Guardias Vacacionales y Vacaciones';
// El nombre del modelo para mencionar al nombre del registro.
const _nameModelSingular = 'la Configuración de Guardias Vacacionales y Vacaciones';

// Formatea el registro antes insertarlo al form.
const _formatRecordForRead = (record) => {
  const dataFormatedById = {
    periodo_fiscal: record?.periodo_fiscal?.id ?? record?.periodo_fiscal,
    estados_globales: record?.estados_globales?.id,
  };
  return dataFormatedById;
};
// Formatea el registro antes de enviarlo al backend.
/** necesario en fechas, de lo contrario solo volver a mandar el record */
const _formatRecordForSend = (record) => record;

// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelInfoConfigGuardVacaGeneral = {
  cliente: _cliente,
  nameModel: _nameModel,
  nameModelSingular: _nameModelSingular,
  formatter: { // el actor que formatea.
    formatRecordForRead: _formatRecordForRead,
    formatRecordForSend: _formatRecordForSend,
  },
};

/**
 * GET Guardias Vacacionales General
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getGuardiasVacacionalesGeneral = async (params) => (
  _cliente.obtenerListaDeRegistros(params)
);
